import React,{memo} from "react";
import { Col, Divider, Row } from "antd";
import { createUseStyles } from "react-jss";
import { COLORS, i18n, useDateChange, useGetAdminDashboard } from "core";
import { StatisticBox } from "../../molecules";
const useStyle = createUseStyles<string, unknown, COLORS>((colors) => ({
  
  background: {
    width: '100%',
    height: '300px',
    marginTop: '-40px',
    marginRight: '-40px',
    '@media(max-width:658px)': {
      display:'none'
    },
    backgroundColor: colors.theme01,
    position: 'absolute',
  },
  container:{
    display:"flex",
    justifyContent:'space-evenly' 
  },
  tilte:{
    color:colors.white,
    marginBottom:'20px'
  }
}));

const Main = memo(() => {
  const classes = useStyle();
  const {changeNumberToPersian}=useDateChange()
  // const { data: { data } = {}, isFetching } =
  //   useGetStatisticDashboard();
  // const { i18n } = useTranslation();
  // const Items = useMemo(
  //   () => [
  //     {
  //       title: i18n.t('usersCount'),
  //       value: data?.user_count,
  //       icon: <UserOutlined />,
  //       create: `/dashboard/users/${routesName.CREATEUSERS}`,
  //       view: `/dashboard/users/${routesName.USERSLIST}`,
  //     },
  //     {
  //       title: i18n.t('trunkNumbersCount'),
  //       value: data?.trunk_number_count,
  //       icon: <PhoneOutlined />,
  //       create: `/dashboard/trunknumbers/${routesName.CREATETRUNKNUMBERS}`,
  //       view: `/dashboard/trunknumbers/${routesName.TRUNKNUMBERSLIST}`,
  //     },
  //     {
  //       title: i18n.t('queueNumbersCount'),
  //       value: data?.queue_number_count,
  //       icon: <HiOutlineQueueList />,
  //       create: `/dashboard/queue/${routesName.CREATEQUEUE}`,
  //       view: `/dashboard/queue/${routesName.QUEUELIST}`,
  //     },
  //     {
  //       title: i18n.t('campainsCount'),
  //       value: data?.campaign_count,
  //       icon: <TeamOutlined />,
  //       create: `/dashboard/campaign/${routesName.CREATECAMPAIGN}`,
  //       view: `/dashboard/campaign/${routesName.CAMPAIGNLIST}`,
  //     },
  //   ],
  //   [data]
  // );
 
  const {data}=useGetAdminDashboard()
  
  return (
    <Col>
      <Row><h1 className={classes.tilte}>{i18n.t("statisticReports")}</h1></Row>
    <div className={classes.container}>
      <StatisticBox text={i18n.t('allUsers')} value={data?.data.allUsers}/>
      <StatisticBox text={i18n.t('onlineUsers')} value={data?.data?.onlineUsers}/>
      <StatisticBox text={i18n.t('allChannels')} value={data?.data?.allChannels}/>
      <StatisticBox text={i18n.t('allGroups')} value={data?.data?.allGroups}/>
    </div>
       {/* <Divider/> */}
   </Col>
  );
});

export { Main };
